import { ClientCompany, Workstation } from "./clientCompanies";

export type EmployeeLocationType = "land" | "sea" | "other" | "unknown";

export type Gender = "male" | "female" | "other" | "unknown";

export type Employee = {
  id: string;
  workstationId: string | null;
  fullName: string;
  nationalId: string;
  locationType: EmployeeLocationType;
  email: string | null;
  phone: string | null;
  gender: Gender | null;
  department: string | null;
  jobTitle: string | null;
  seaYears: string | null;
  landline: string | null;
  nationality: string | null;
  note: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  workstation: (Workstation & { clientCompany: ClientCompany }) | null;
  clientCompany?: ClientCompany;
};

export type NationalRegistrySuggestion = {
  kennitala: string;
  fullName: string;
};

export type EmployeeMissingName = Employee & {
  suggestion: NationalRegistrySuggestion | null;
};

export const getEmployeeClientCompany = (employee: Employee) =>
  employee.workstation?.clientCompany ?? employee.clientCompany;

export const employeeLocationTypeOptions: EmployeeLocationType[] = [
  "land",
  "sea",
  "other",
  "unknown",
];

const locationTypeLabels: Record<EmployeeLocationType, string> = {
  land: "On land",
  sea: "At sea",
  other: "Other",
  unknown: "Unknown",
};

export const formatEmployeeLocationType = (
  locationType: EmployeeLocationType,
) => locationTypeLabels[locationType] ?? locationType;

export const genderOptions: Gender[] = [
  "male",
  "female",
  "other",
  "unknown",
];

const genderLabels: Record<Gender, string> = {
  male: "Male",
  female: "Female",
  other: "Other",
  unknown: "Unknown",
};

export const formatGender = (gender: Gender) =>
  genderLabels[gender] ?? gender;
